import React from "react";
import { useObserver, useLocalStore } from "mobx-react";
import { makeStyles } from "@material-ui/core/styles";
import { SpinnerOverlay } from "@components";
import { ConsultantImportResultOK } from "./utils";
import { ConsultantImportStore } from "./ConsultantImportStore";
import { Upload } from "./components/Upload";
import { UploadResult } from "./components/UploadResult";
import { FinalResult } from "./components/FinalResult";

export function ConsultantImportPage() {
  const classes = useStyles({});

  const store = useLocalStore(() => new ConsultantImportStore());

  return useObserver(() => (
    <div className={classes.root}>
      <SpinnerOverlay show={store.isLoading} />

      {store.fsm.is("init") && <Upload store={store} />}
      {store.fsm.is("editing") && <UploadResult store={store} />}
      {store.fsm.is("result") && (
        <FinalResult
          result={store.importResult as ConsultantImportResultOK}
          onStartAgain={store.toInit}
        />
      )}
    </div>
  ));
}

const useStyles = makeStyles(() => ({
  root: {
    maxHeight: "100vh",
    minHeight: "100vh",
    overflowY: "auto"
  }
}));
